import type { ReactNode } from 'react';

type TNamedContainers = Record<string, ReactNode>;

/** Удалить из текста prefix и преобразовать в camelCase  */
const clearText = (text: string, prefix: string) =>
    text.replace(prefix, '').replace(/^\w/, c => c.toLowerCase());

/** Разбить NamedContainers на два объекта, в одном экраны для карты экранов, во втором тексты для объекта с текстами  */
export const splitNamedContainer = (obj: TNamedContainers) => {
    const screenBlocks: TNamedContainers = {};
    const textBlocks: TNamedContainers = {};

    for (const key in obj) {
        if (key.startsWith('screen')) {
            screenBlocks[clearText(key, 'screen')] = obj[key];
        }
        if (key.startsWith('text')) {
            textBlocks[clearText(key, 'text')] = obj[key];
        }
    }

    return {
        screenBlocks,
        textBlocks,
    };
};
